<!-- <div style="min-height: 55dvh;"></div> -->
<p-dialog [closable]="true" [(visible)]="downloadModal" [modal]="true" [style]="{width: '416px'}"
    id="downloadModalPopup" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false" [closable]="false" [position]="position">
    <div class="downloadbody">
        <div class="topleftbg">
            <img src="../../../../assets/images/download/topleft.png" alt="">
        </div>
        <div class="bottomrightbg">
            <img src="../../../../assets/images/download/bottomright.png" alt="">
        </div>
        <div class="bottomleftbg">
            <img src="../../../../assets/images/download/bottomleft.png" alt="">
        </div>
        <!-- <div class="download-header">
            <button (click)="downloadModal = false" class="closeBtn">
                <img src="assets/images/download/close.svg" alt="">
            </button>
        </div> -->
        <div class="bannerImage">
            <img src="../../../../assets/images/download/leander.png" alt="">
        </div>
        <div class="modalTitleImage">
            <img src="../../../../assets/images/download/modalTile.svg" alt="">
        </div>

        <div class="downloadList">
            <ul>
                <li>
                    <a href="https://play.google.com/store/apps/details?id=com.wiantech.tplsport&pcampaignid=web_share">
                        <img src="../../../../assets/images/download/btn1.png" alt="">
                    </a>
                </li>
                <li>
                    <a href="https://apps.apple.com/in/app/tpl-tennis-premier-league/id6461867254">
                        <img src="../../../../assets/images/download/btn2.png" alt="">
                    </a>
                </li>
            </ul>
        </div>

        <div class="orTitle">
            <div class="line"></div>
            <p>OR</p>
            <div class="line"></div>
        </div>
        <div class="scanner">
            <img src="../../../../assets/images/download/qrcode.png" alt="">
        </div>
        <div class="notesdiv">
            <p>Click the buttons above to download the <span>App!</span></p>
        </div>
    </div>
</p-dialog><div style="min-height: 55dvh;"></div>
<p-dialog [closable]="true" [(visible)]="downloadModal" [modal]="true" [style]="{width: '416px'}"
    id="downloadModalPopup" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false" [closable]="false" [position]="position">
    <div class="downloadbody">
        <div class="topleftbg">
            <img src="../../../../assets/images/download/topleft.png" alt="">
        </div>
        <div class="bottomrightbg">
            <img src="../../../../assets/images/download/bottomright.png" alt="">
        </div>
        <div class="bottomleftbg">
            <img src="../../../../assets/images/download/bottomleft.png" alt="">
        </div>
        <!-- <div class="download-header">
            <button (click)="downloadModal = false" class="closeBtn">
                <img src="assets/images/download/close.svg" alt="">
            </button>
        </div> -->
        <div class="bannerImage">
            <img src="../../../../assets/images/download/leander.png" alt="">
        </div>
        <div class="modalTitleImage">
            <img src="../../../../assets/images/download/modalTile.svg" alt="">
        </div>

        <div class="downloadList">
            <ul>
                <li>
                    <a href="https://play.google.com/store/apps/details?id=com.wiantech.tplsport&pcampaignid=web_share">
                        <img src="../../../../assets/images/download/btn1.png" alt="">
                    </a>
                </li>
                <li>
                    <a href="https://apps.apple.com/in/app/tpl-tennis-premier-league/id6461867254">
                        <img src="../../../../assets/images/download/btn2.png" alt="">
                    </a>
                </li>
            </ul>
        </div>

        <div class="orTitle">
            <div class="line"></div>
            <p>OR</p>
            <div class="line"></div>
        </div>
        <div class="scanner">
            <img src="../../../../assets/images/download/qrcode.png" alt="">
        </div>
        <div class="notesdiv">
            <p>Click the buttons above to download the <span>App!</span></p>
        </div>
    </div>
</p-dialog>